import { Client } from '@taruvi/sdk';

const hostname = window.location.hostname;
const subdomain = hostname.split('.')[0];
const baseUrl = `https://${subdomain}.taruvibase.cloud`;


export const taruviClient = new Client({
  apiKey: import.meta.env.VITE_API_KEY,
  apiUrl: baseUrl,
  appSlug: import.meta.env.VITE_APP_SLUG, //change later
});
